import css from 'styled-jsx/css';
import { colors, typography, zIndex } from '../../../config/styles';

const PopoverStyles = css`
  .overlay-popover {
    position: sticky;
    top: 0;
    z-index: 999;
    background: none;
  }

  .popover-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    outline: none;
  }

  .sticky {
    position: sticky;
    z-index: 100;
  }

  .popover {
    background: ${colors.white.shade1};
    box-shadow: 0 5px 75px rgba(0, 0, 0, 0.25);
    display: block;
    margin: 0;
    position: absolute;
    top: calc(100% + 10px);
    width: 200px;
    cursor: initial;
    right: 0;
    min-width: 240px;
    padding: 40px 25px 20px;
    white-space: initial;
    z-index: ${zIndex.popover.content};
  }

  .fullWidth {
    width: calc(100% - 16px);
  }

  .transparent .popover {
    display: flex;
    padding: 12px 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    background: rgba(233, 237, 241, 0.9);
    border-radius: 16px;
    border: 1px solid #cad1d9;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);
    backdrop-filter: blur(2px);
  }

  .popover-container.bottom .popover {
    &::before {
      border-color: transparent transparent ${colors.white.shade1};
      border-style: solid;
      border-width: 0 9px 11px;
      content: '';
      height: 0;
      right: 9px;
      top: -10px;
      width: 0;
      position: absolute;
    }
    &::after {
      width: 100%;
      content: '';
      right: 0;
      height: 10px;
      top: -10px;
      background: transparent;
      position: absolute;
    }
  }

  .popover.compact {
    padding: 20px 30px;
    min-width: 280px;
    &::before {
      right: 23px;
    }
  }

  .popover.minimal {
    padding: 35px 39px 35px 28px;
    min-width: 308px;
    &::before {
      right: 23px;
    }
  }

  .popover-container.left .popover {
    top: calc(0% - 200%);
    left: calc(100% + 33px);
    &::before {
      content: '';
      border-style: solid;
      border-width: 9px 8px 9px 0;
      border-color: transparent ${colors.white.shade1} transparent transparent;
      position: absolute;
      width: 0;
      height: 0;
      left: -8px;
      top: calc(40%);
    }
    &::after {
      content: '';
      width: 10px;
      height: 100%;
      left: -10px;
      top: 0;
      background: transparent;
      position: absolute;
    }
  }

  .popover-container.center .popover {
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
  }

  :global(.doc-click-overlay) {
    position: relative;
    display: flex;
    height: 100%;
    align-items: flex-end;
    justify-content: center;
    cursor: pointer;
  }

  .popover :global(.button) {
    letter-spacing: 1px;
  }

  .popover :global(.dropdown-wrapper .dropdown-list) {
    @mixin tabletToDesktop {
      max-width: 240px;
    }
  }

  .popover :global(.actions .button.button-secondary) {
    padding: 0 10px;
    font-size: ${typography.sm};
  }

  .popover :global(.dropdown-wrapper .dropdown-header .dropdown-select) {
    min-width: 240px;
  }
`;

export default PopoverStyles;
